import './AdminSection.css'
import { useEffect, useState } from 'react'
import { api } from '../../../utils/utils'
import { Header } from '../../Header'
import { IncomeSection } from './IncomeSection'
import { ChartSection } from './ChartSection'


export function AdminSection() {
    const [ticketData, setTicketData] = useState([])
    const [loading, setLoading] = useState(true)

    const getTickets = async () => {
        api.get('/tickets')
            .then((res) => {
                setTicketData(res.data)
                // console.log(res.data)
            })
            .catch((err) => {
                console.log(err.message)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        getTickets()
    }, [])

    return (
        <>
        <Header />
        <span id="admin-section-wrapper">
            <section id="admin-section">
                <IncomeSection ticketData={ticketData}/>
                <ChartSection ticketData={ticketData}/>
            </section>
        </span>
        </>
    )
}